<template>
  <b-modal
    :id="modalId"
    :title="$t('simulation.add.poste.honoraire')"
    centered
    :ok-title="$t('Valider')"
    :cancel-title="$t('Annuler')"
    ok-variant="primary"
    cancel-variant="outline-primary"
    no-close-on-backdrop
    @ok="handleOk"
    @cancel="handleCancel">

    <div class="callout">{{ $t('simulationLot.add.poste.honoraire.modale.desc') }}</div>

    <div class="row mb-2 mt-4">
      <div class="col-md-12">
        <span class="bold-text custom-title">{{ simulationHonoraire.type }} (Simulation)</span>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <b-form-group
          :label="$t('Associer un poste')"
          class="medium-label mb-4"
          label-for="poste-input">
          <b-form-select
            id="poste-input"
            v-model="currentSelection"
            @change="addPoste"
            required>
            <option value="" selected>{{ $t('simulation.poste.honoraire.name.placeholder') }}</option>
            <option v-for="option in postes" :key="option.value" :value="option.value">
              {{ $t(option.text) }}
            </option>
          </b-form-select>
          <div class="selected-badges mt-4 mb-5">
            <b-badge
              v-for="poste in linkedHonoraires"
              :key="poste.id"
              pill
              variant="primary"
              class="mr-2 mb-2 badge-custom">
              <span class="badge-close" @click.stop="removePoste(poste)">×</span>
              <span class="badge-text">{{ getBadgeText(poste) }}</span>
            </b-badge>
          </div>
        </b-form-group>
      </div>
    </div>

  </b-modal>
</template>

<script>
import api from '../../../services/api'

export default {
  name: 'AddSimulationPosteHonoraireModal',

  props: {
    simulationHonoraire: {
      type: Object,
      required: true
    },
    modalId: {
      type: String,
      required: true
    },
    operationId: {
      type: Number,
      default: null
    }
  },

  data() {
    return {
      postes: [],
      allPostes: [],
      selectedPostes: [],
      currentSelection: '',
      linkedHonoraires: []
    }
  },

  emits: ['didAddPosteHonoraire'],

  mounted() {
    console.log('Modal ouvert avec ID:', this.modalId)

  },

  methods: {
    show() {
      this.currentSelection = ""
      this.selectedPostes = []

      const isLotSimulation = this.simulationHonoraire.simulationLot && this.simulationHonoraire.simulationLot.id !== null


      this.fetchAvailableOperationHonoraires()
      this.fetchLinkedOperations()
    },

    fetchAvailableOperationHonoraires() {
      console.log('operationId dans fetchAvailableOperationHonoraires:', this.operationId)
      api
        .get(`/simulationHonoraire/getAvaiblesOperationHonoraire?operationId=${this.operationId}`)
        .then(response => {
          console.log('OperationHonoraires disponibles:', response.data)
          this.updatePostesLists()
        })
        .catch((error) => {
          console.error('Erreur lors de la récupération des honoraires:', error)
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'SimulationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    fetchLinkedOperations() {
      api
        .get(`/simulationHonoraire/getLinkedOperations?simulationHonoraireId=${this.simulationHonoraire.id}`)
        .then(response => {
          console.log('Honoraires liés:', response.data)
          const avpHonoraires = response.data.honorairesAVP.map(p => ({
            ...p,
            type: 'AVP',
            operationType: 'AVP',
            name: p.tostring
          }))
          const exeHonoraires = response.data.honorairesEXE.map(p => ({
            ...p,
            type: 'EXE',
            operationType: 'EXE',
            name: p.tostring
          }))
          this.linkedHonoraires = [...avpHonoraires, ...exeHonoraires]
        })
        .catch(error => {
          console.error('Erreur lors de la récupération des honoraires liés:', error)
        })
    },

    async updatePostesLists() {
      try {
        const response = await api.get('/simulationHonoraire/getAvaiblesOperationHonoraire', {
          params: {
            operationId: this.operationId
          }
        })

        // Vérifier si c'est une simulation de lot
        const isLotSimulation = this.simulationHonoraire.simulationLot && this.simulationHonoraire.simulationLot.id !== null
        console.log('Type de simulation dans updatePostesLists:', isLotSimulation ? 'LOT' : 'GENERAL')

        // Traiter les postes AVP
        const postesAVP = response.data.AVP
          .filter(poste => {
            if (isLotSimulation) {
              return poste.operationLot && poste.operationLot.id
            } else {
              return !poste.operationLot || !poste.operationLot.id
            }
          })
          .map(poste => ({
            value: poste.id,
            name: poste.tostring,
            ids: [poste.id],
            types: ['AVP'],
            text: `${poste.tostring} (AVP)`,
            operationType: 'AVP'
          }))

        // Traiter les postes EXE
        const postesEXE = response.data.EXE
          .filter(poste => {
            if (isLotSimulation) {
              return poste.operationLot && poste.operationLot.id
            } else {
              return !poste.operationLot || !poste.operationLot.id
            }
          })
          .map(poste => ({
            value: poste.id,
            name: poste.tostring,
            ids: [poste.id],
            types: ['EXE'],
            text: `${poste.tostring} (EXE)`,
            operationType: 'EXE'
          }))

        // Combiner les postes AVP et EXE
        this.allPostes = [...postesAVP, ...postesEXE].sort((a, b) => a.text.localeCompare(b.text))
        this.postes = [...this.allPostes]
      } catch (error) {


      }
    },

    addPoste() {


      if (this.currentSelection && !this.selectedPostes.includes(this.currentSelection)) {
        // Trouver le poste par sa valeur ou par l'un de ses ids
        const poste = this.allPostes.find(p =>
          p.value === this.currentSelection ||
          p.ids.includes(this.currentSelection)
        )


        if (poste) {

          // Ajouter un poste simple
          const newPoste = {
            id: poste.ids[0],
            name: poste.name,
            operationType: poste.operationType
          }
          this.linkedHonoraires.push(newPoste)

          // Add to selectedPostes for tracking
          this.selectedPostes.push(this.currentSelection)


          // Supprimer l'option sélectionnée du dropdown
          this.postes = this.postes.filter(p => p.value !== this.currentSelection)
        }
      }
      // Always reset currentSelection to fix the placeholder bug
      this.currentSelection = ""

    },

    getPosteText(value, options) {
      const posteComplet = this.allPostes.find(p => p.value === value || p.ids.includes(value))
      if (posteComplet) {
        return `${posteComplet.name} (${posteComplet.operationType})`
      }
      return value
    },

    getBadgeText(poste) {
      if (typeof poste === 'object') {
        return `${poste.name} (${poste.operationType})`
      }

      const posteComplet = this.allPostes.find(p => p.value === poste || p.ids.includes(poste))
      if (posteComplet) {
        return `${posteComplet.name} (${posteComplet.operationType})`
      }
      return poste
    },

    removePoste(value) {


      if (typeof value === 'object') {
        // Supprimer le poste des honoraires liés
        this.linkedHonoraires = this.linkedHonoraires.filter(p => p.id !== value.id)


        // Remove from selectedPostes if it exists there
        this.selectedPostes = this.selectedPostes.filter(id => id !== value.id)

        // Ajouter le poste individuel au dropdown
        const posteToAdd = {
          value: value.id,
          name: value.name,
          ids: [value.id],
          types: [value.operationType],
          text: `${value.name} (${value.operationType})`,
          operationType: value.operationType
        }

        // Vérifier si le poste existe déjà dans le dropdown
        const existingPosteIndex = this.postes.findIndex(p => p.value === value.id)
        if (existingPosteIndex >= 0) {
          this.postes[existingPosteIndex] = posteToAdd
        } else {
          this.postes.push(posteToAdd)
        }

        // Ajouter ou mettre à jour le poste dans allPostes
        const existingAllPosteIndex = this.allPostes.findIndex(p => p.value === value.id)
        if (existingAllPosteIndex >= 0) {
          this.allPostes[existingAllPosteIndex] = posteToAdd
        } else {
          this.allPostes.push(posteToAdd)
        }

        this.postes.sort((a, b) => a.text.localeCompare(b.text))

      } else {
        // Gestion des postes pré-sélectionnés
        const foundPoste = this.linkedHonoraires.find(p => p.id === value)
        if (foundPoste) {
          // Supprimer le badge
          this.linkedHonoraires = this.linkedHonoraires.filter(p => p.id !== value)

          // Remove from selectedPostes
          this.selectedPostes = this.selectedPostes.filter(id => id !== value)

          // Ajouter le poste individuel au dropdown
          const posteToAdd = {
            value: value,
            name: foundPoste.name,
            ids: [value],
            types: [foundPoste.operationType],
            text: `${foundPoste.name} (${foundPoste.operationType})`,
            operationType: foundPoste.operationType
          }

          // Vérifier si le poste existe déjà dans le dropdown
          const existingPosteIndex = this.postes.findIndex(p => p.value === value)
          if (existingPosteIndex >= 0) {
            this.postes[existingPosteIndex] = posteToAdd
          } else {
            this.postes.push(posteToAdd)
          }

          // Ajouter ou mettre à jour le poste dans allPostes
          const existingAllPosteIndex = this.allPostes.findIndex(p => p.value === value)
          if (existingAllPosteIndex >= 0) {
            this.allPostes[existingAllPosteIndex] = posteToAdd
          } else {
            this.allPostes.push(posteToAdd)
          }

          this.postes.sort((a, b) => a.text.localeCompare(b.text))

        }
      }

      // Reset currentSelection to fix the placeholder bug
      this.currentSelection = ""
    },

    handleOk() {
      this.handleSubmit()
    },

    handleCancel() {
      this.hideModal()
    },

    handleSubmit() {
      const linkedIds = this.linkedHonoraires.map(p => p.id)
      const selectedIds = [...this.selectedPostes]
      const allIds = [...new Set([...linkedIds, ...selectedIds])]

      const formData = new FormData()
      formData.append('simulationHonoraireId', this.simulationHonoraire.id)
      formData.append('operationHonoraireIds', allIds.join(','))

      api
        .post('/simulationHonoraire/linkOperationHonoraire', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {
          console.log('Honoraires liés avec succès:', response.data)
          this.$emit('didAddPosteHonoraire', response.data)
          this.hideModal()
        })
        .catch(error => {
          console.error('Erreur lors de la liaison des honoraires:', error)
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'SimulationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    hideModal() {
      this.$bvModal.hide(this.modalId)
    }
  }
}
</script>

<style scoped>
.custom-title {
  font-size: 1rem;
  color: var(--main-text-color);
}

.selected-badges {
  display: flex;
  flex-wrap: wrap;
}

.badge-custom {
  display: flex;
  align-items: center;
  padding: 0.2rem 0.7rem;
  border-radius: 0.5rem;
  background-color: var(--dragee);
  border: 2px solid var(--main-blue-hover);
}

.badge-text {
  font-size: 0.9rem;
  margin-left: 0.5rem;
  color: var(--main-color);
}

.badge-close {
  cursor: pointer;
  font-size: 1.8rem;
  line-height: 1;
  color: #000000;
}

.callout{
  background-color: transparent;
  color: var(--tertiary-text-color);
  padding: 0px;
  font-size: 0.8rem;
  margin-top:  -10px;
  border-radius: 0.5rem;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/simulation/components/AddSimulationPosteHonoraireModal.vue